import { createVanIconComponent } from "./van"

const Ellipsis = createVanIconComponent("ellipsis")
export default Ellipsis
